import { Theme } from '../enums';
import { HexColor, isColorBright } from './colorUtils';

export const getThemeBasedOnBackground = (bgColorHex: HexColor | undefined): Theme => {
  return isColorBright(bgColorHex) ? Theme.Light : Theme.Dark;
};
